import { render, staticRenderFns } from "./ProductOrderList.vue?vue&type=template&id=08ee2575&scoped=true"
import script from "./ProductOrderList.vue?vue&type=script&lang=js"
export * from "./ProductOrderList.vue?vue&type=script&lang=js"
import style0 from "./ProductOrderList.vue?vue&type=style&index=0&id=08ee2575&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ee2575",
  null
  
)

export default component.exports